import { render, staticRenderFns } from "./SendRecord.vue?vue&type=template&id=3a25dc40&scoped=true"
import script from "./SendRecord.vue?vue&type=script&lang=js"
export * from "./SendRecord.vue?vue&type=script&lang=js"
import style0 from "./SendRecord.vue?vue&type=style&index=0&id=3a25dc40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a25dc40",
  null
  
)

export default component.exports